export const groupSupportProps = {
  fontSize: { key: 'fontSize', validate: v => v !== '' && v !== undefined },
  fill: { key: 'fill', validate: v => +v !== -1, propEditorAlias: 'fg' },
  backgroundColor: { key: 'backgroundColor', validate: () => true },
  textAlign: { key: 'textAlign', validate: v => +v !== -1 },
  lineHeight: { key: 'textAlign', validate: v => +v !== -1 },
  fontStyle: { key: 'fontStyle', validate: () => true },
  fontWeight: { key: 'fontWeight', validate: () => true },
  fontFamily: { key: 'fontFamily', validate: v => v !== undefined },
  fgType: { key: 'fontFamily', validate: v => v !== undefined },
  fgGradientDirection: { key: 'fontFamily', validate: v => v !== undefined },
  fgGradientStart: { key: 'fontFamily', validate: v => v !== undefined },
  fgGradientEnd: { key: 'fontFamily', validate: v => v !== undefined },
};

export const groupSupportKey = Object.keys(groupSupportProps);
export const groupSupportPropEditorKey = Object.keys(groupSupportProps).map(
  key => groupSupportProps[key].propEditorAlias || key
);

export default (formData, t) => {
  return {
    fields: [
      {
        type: 'group',
        label: t('propsEditor.textStyle'),
        expanded: true,
        labelWidth: '60px',
        children: [
          { as: 'font-family', label: t('propsEditor.fontFamily'), name: 'fontFamily', compStyle: { width: '168px' } },
          { as: 'slider', name: 'fontSize', min: 1, max: 500, label: t('propsEditor.fontSize') },
          {
            as: 'radio-group',
            label: t('propsEditor.textColorType'),
            name: 'fgType',
            list: [
              { value: 'pure', label: t('propsEditor.fgTypePure') },
              { value: 'gradient', label: t('propsEditor.fgTypeGradient') },
            ],
          },
          {
            as: 'color',
            show: () => formData.fgType === 'pure',
            label: t('propsEditor.textColor'),
            name: 'fg',
          },
          {
            as: 'radio-group',
            show: () => formData.fgType === 'gradient',
            label: t('propsEditor.fgGradientDirection'),
            name: 'fgGradientDirection',
            list: [
              { value: 'h', label: t('propsEditor.horizontal') },
              { value: 'v', label: t('propsEditor.vertical') },
            ],
          },
          {
            type: 'inline',
            children: [
              {
                as: 'color',
                labelStyle: { width: '60px' },
                style: { width: '150px' },
                show: () => formData.fgType === 'gradient',
                label: t('propsEditor.fgGradientStart'),
                name: 'fgGradientStart',
              },
              {
                as: 'color',
                show: () => formData.fgType === 'gradient',
                label: t('propsEditor.fgGradientEnd'),
                name: 'fgGradientEnd',
              },
            ],
          },
          { as: 'color', label: t('propsEditor.backgroundColor'), name: 'backgroundColor' },
          { as: 'align-group', label: '', name: 'textGroupAlign' },
          {
            type: 'inline',
            children: [
              { as: 'align', label: '', name: 'textAlign' },
              { as: 'font-style', label: '', name: 'fontStyle' },
              { as: 'text-case', label: '', name: 'textCase' },
            ],
          },
          {
            as: 'number',
            label: t('common.lineHeight'),
            placeholder: t('common.lineHeight'),
            name: 'lineHeight',
            step: 0.1,
            min: 0.1,
            compStyle: { width: '72px' },
          },
        ],
      },
      // {
      //   type: 'group',
      //   label: '阴影设置',
      //   expanded: true,
      //   labelWidth: '60px',
      //   children: [
      //     { as: 'slider', label: '阴影范围', labelBlock: true, name: 'shadowBlur' },
      //     { as: 'color', label: '阴影颜色', name: 'bg' },
      //   ],
      // },
    ],
  };
};
